import React, { useMemo, useEffect, useState, useRef } from "react";
import { Formik } from "formik";
import { useEventContext } from "./EventDataContext";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
const prepareFilter = (values) => {
  const {
    idFilter,
    dateFilter,
    activeFilter,
  } = values;
  const filter = {};
  
  filter.id = idFilter !== "" ? idFilter : "";
  filter.date = dateFilter !== "" ? dateFilter : "";
  filter.active_id = activeFilter !== "" ? activeFilter : "";


  return filter;
};

export function EventFilter({ filterData, origData, loading }) {
  const formRef = useRef();
  const DROPDOWN_TYPE = useEventContext().TYPES;
  const [dataLoaded, setDataLoaded] = useState(false);
  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const context = useEventContext();
  const applyFilter = (values) => {
    //apply filter here
    filterData(prepareFilter(values));
  };
  const useStyles = makeStyles({
    btnCircleSm: {
      width: "30px",
            height: "30px",
            padding: "0px 7px",
            margin: "2px 1px 1px 1px",
            borderRadius: "15px",
            fontSize: "4px",
            textAlign: "center",
    },
  });
  const classes = useStyles();

  useEffect(() => {
    const initialValues = {
      idFilter: "",
      dateFilter: "",
      activeFilter: "1",
    };
    applyFilter(initialValues);
  }, [origData]);

  //fetching classes for a branch
  useEffect(() => {
    formRef.current.click();
  }, [context.refetch, loading]);

  return (
    <>
      <Formik
        initialValues={{
          idFilter: "",
          dateFilter: "",
          activeFilter: "1",
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
            <div className="col-lg-2">
                <input
                  className="form-control"
                  placeholder="ID"
                  name="idFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("idFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.idFilter}
                ></input>
                <small className="form-text text-muted">
                  <b>Filter</b> by ID
                </small>
              </div>
              <div className="col-lg-2">
                <select
                  className="form-control"
                  placeholder="Filter by Status"
                  name="activeFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("activeFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.activeFilter}
                >
                  <option value="">All</option>

                  {DROPDOWN_TYPE.ACTIVE &&
                    DROPDOWN_TYPE.ACTIVE.map((a) => (
                      <option key={a.id} value={a.id}>
                        {a.value}
                      </option>
                    ))}
                </select>
                <small className="form-text text-muted">
                  <b>Filter</b> by Status
                </small>
              </div>
              
              <button
                type={"submit"}
                ref={formRef}
                style={{ display: "none" }}
                onClick={handleSubmit}
              />

               <button className={`btn btn-sm btn-circle btn-light ${classes.btnCircleSm}`} onClick={(e) => (setShowMoreFilters(!showMoreFilters))}><span className="svg-icon svg-icon-md svg-icon-danger">
              <i className={`fa text-${showMoreFilters ? `secondary fa-minus`: `primary fa-plus`}`}></i>
                          </span>
              </button>
            </div>
            {showMoreFilters && <div className="form-group row">
            
              <div className="col-lg-3">
                <input
                  type="date"
                  className={`form-control`}
                  placeholder="Filter by Date"
                  name="dateFilter"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue("dateFilter", e.target.value);
                    handleSubmit();
                  }}
                  value={values.dateFilter}
                />
                <small className="form-text text-muted">
                  <b>Filter</b> by Date
                </small>
              </div>
                </div>
                }
          </form>
        )}
      </Formik>
    </>
  );
}
